import React from 'react'
import s from './index.module.scss'
import classNames from 'classnames'
import { ReactComponent as ExcelIcon } from '../../../assets/icons/excel.svg'

interface IProps extends React.HTMLProps<HTMLButtonElement> {
	variant: 'filled' | 'text' | 'export'
	type?: 'button' | 'submit'
	onClick?: () => void
	className?: string
}

const Button: React.FC<IProps> = ({ variant = 'filled', type = 'button', onClick, className, children, ...props }) => {
	return (
		<button
			type={type}
			className={classNames(s.btn, className, {
				[s.btnFilled]: variant === 'filled',
				[s.btnText]: variant === 'text',
				[s.btnExport]: variant === 'export',
			})}
			onClick={onClick}
			{...props}
		>
			{variant === 'export' ? (
				<>
					Експорт в Excel <ExcelIcon />
				</>
			) : (
				children
			)}
		</button>
	)
}

export default Button
